module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10260.8119e464.jpg";